<template>
  <button
    type="button"
    class="tw-flex tw-items-center tw-justify-center tw-mx-2 tw-rounded-full tw-border-none tw-bg-primary-grey-100/0 tw-outline-none tw-ring-4 tw-ring-primary-grey-100/0"
    :class="classes"
    :data-test-id="testId"
    :disabled="disabled || readonly"
    @click="emitClick"
  >
    <slot />
  </button>
</template>

<script lang="ts" setup>
import { computed } from "vue";

export interface Props {
  testId: string;
  disabled?: boolean;
  readonly?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  readonly: false,
});

const emit = defineEmits<{
  (event: "on-click"): void;
}>();

const emitClick = (): void => {
  emit("on-click");
};

const classes = computed(() => {
  if (props.disabled) {
    return "tw-text-primary-grey-200 tw-cursor-default";
  }
  if (props.readonly) {
    return "tw-text-primary-grey-700 tw-cursor-not-allowed";
  }
  return "tw-text-primary-grey-950 tw-transition-all hover:tw-bg-primary-grey-100 hover:tw-text-primary-grey-950 hover:tw-ring-primary-grey-100 active:tw-bg-primary-grey-200 active:tw-ring-primary-grey-200 dark:hover:tw-bg-primary-grey-200 dark:hover:tw-ring-primary-grey-200 dark:active:tw-bg-primary-grey-100 dark:active:tw-ring-primary-grey-100";
});
</script>
